/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AccessoryTypeEnum } from '../models/accessory-type-enum';
import { CalculationTypeEnum } from '../models/calculation-type-enum';
import { ProductColorListDto } from '../models/product-color-list-dto';
import { ProductFinishesListDto } from '../models/product-finishes-list-dto';
import { ProductListDto } from '../models/product-list-dto';
import { ProductThicknessListDto } from '../models/product-thickness-list-dto';
import { RoofProducerEnum } from '../models/roof-producer-enum';
import { RoofProductDto } from '../models/roof-product-dto';
import { RoofProductTypeEnum } from '../models/roof-product-type-enum';

@Injectable({
  providedIn: 'root',
})
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation productsControllerGetProducts
   */
  static readonly ProductsControllerGetProductsPath = '/api/products';

  /**
   * Get products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProducts$Response(
    params: {
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
      withRelations?: boolean;
      readableId?: AccessoryTypeEnum;
      dimension?: string;
      type?: RoofProductTypeEnum;
      calculationType?: CalculationTypeEnum;
      producer: RoofProducerEnum;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ProductListDto>> {
    const rb = new RequestBuilder(this.rootUrl, ProductsService.ProductsControllerGetProductsPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('exclude[]', params['exclude[]'], {});
      rb.query('withRelations', params.withRelations, {});
      rb.query('readableId', params.readableId, {});
      rb.query('dimension', params.dimension, {});
      rb.query('type', params.type, {});
      rb.query('calculationType', params.calculationType, {});
      rb.query('producer', params.producer, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ProductListDto>;
        }),
      );
  }

  /**
   * Get products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProducts(
    params: {
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
      withRelations?: boolean;
      readableId?: AccessoryTypeEnum;
      dimension?: string;
      type?: RoofProductTypeEnum;
      calculationType?: CalculationTypeEnum;
      producer: RoofProducerEnum;
    },
    context?: HttpContext,
  ): Observable<ProductListDto> {
    return this.productsControllerGetProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductListDto>) => r.body as ProductListDto),
    );
  }

  /**
   * Path part for operation productsControllerGetRainSystemCustomizations
   */
  static readonly ProductsControllerGetRainSystemCustomizationsPath = '/api/products/rain-system-customizations';

  /**
   * Get rain system customizations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetRainSystemCustomizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRainSystemCustomizations$Response(
    params?: {},
    context?: HttpContext,
  ): Observable<StrictHttpResponse<{}>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ProductsService.ProductsControllerGetRainSystemCustomizationsPath,
      'get',
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<{}>;
        }),
      );
  }

  /**
   * Get rain system customizations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetRainSystemCustomizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRainSystemCustomizations(params?: {}, context?: HttpContext): Observable<{}> {
    return this.productsControllerGetRainSystemCustomizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<{}>) => r.body as {}),
    );
  }

  /**
   * Path part for operation productsControllerGetProduct
   */
  static readonly ProductsControllerGetProductPath = '/api/products/{productId}';

  /**
   * Get a product by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProduct$Response(
    params: {
      productId: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RoofProductDto>> {
    const rb = new RequestBuilder(this.rootUrl, ProductsService.ProductsControllerGetProductPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<RoofProductDto>;
        }),
      );
  }

  /**
   * Get a product by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProduct(
    params: {
      productId: string;
    },
    context?: HttpContext,
  ): Observable<RoofProductDto> {
    return this.productsControllerGetProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoofProductDto>) => r.body as RoofProductDto),
    );
  }

  /**
   * Path part for operation productsControllerGetRoofFinishes
   */
  static readonly ProductsControllerGetRoofFinishesPath = '/api/products/{productId}/finishes';

  /**
   * Get finishes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetRoofFinishes()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofFinishes$Response(
    params: {
      productId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ProductFinishesListDto>> {
    const rb = new RequestBuilder(this.rootUrl, ProductsService.ProductsControllerGetRoofFinishesPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('exclude[]', params['exclude[]'], {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ProductFinishesListDto>;
        }),
      );
  }

  /**
   * Get finishes.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetRoofFinishes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofFinishes(
    params: {
      productId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
    },
    context?: HttpContext,
  ): Observable<ProductFinishesListDto> {
    return this.productsControllerGetRoofFinishes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductFinishesListDto>) => r.body as ProductFinishesListDto),
    );
  }

  /**
   * Path part for operation productsControllerGetRoofThicknesses
   */
  static readonly ProductsControllerGetRoofThicknessesPath = '/api/products/{productId}/finishes/{finishId}/thickness';

  /**
   * Get thicknesses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetRoofThicknesses()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofThicknesses$Response(
    params: {
      finishId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
      productId: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ProductThicknessListDto>> {
    const rb = new RequestBuilder(this.rootUrl, ProductsService.ProductsControllerGetRoofThicknessesPath, 'get');
    if (params) {
      rb.path('finishId', params.finishId, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('exclude[]', params['exclude[]'], {});
      rb.path('productId', params.productId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ProductThicknessListDto>;
        }),
      );
  }

  /**
   * Get thicknesses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetRoofThicknesses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofThicknesses(
    params: {
      finishId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
      productId: string;
    },
    context?: HttpContext,
  ): Observable<ProductThicknessListDto> {
    return this.productsControllerGetRoofThicknesses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductThicknessListDto>) => r.body as ProductThicknessListDto),
    );
  }

  /**
   * Path part for operation productsControllerGetRoofColors
   */
  static readonly ProductsControllerGetRoofColorsPath =
    '/api/products/{productId}/finishes/{finishId}/thickness/{thicknessId}/colors';

  /**
   * Get colors.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetRoofColors()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofColors$Response(
    params: {
      productId: string;
      finishId: string;
      thicknessId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ProductColorListDto>> {
    const rb = new RequestBuilder(this.rootUrl, ProductsService.ProductsControllerGetRoofColorsPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.path('finishId', params.finishId, {});
      rb.path('thicknessId', params.thicknessId, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('exclude[]', params['exclude[]'], {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ProductColorListDto>;
        }),
      );
  }

  /**
   * Get colors.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetRoofColors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetRoofColors(
    params: {
      productId: string;
      finishId: string;
      thicknessId: string;
      limit?: number;
      offset?: number;
      'exclude[]'?: Array<'total'>;
    },
    context?: HttpContext,
  ): Observable<ProductColorListDto> {
    return this.productsControllerGetRoofColors$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductColorListDto>) => r.body as ProductColorListDto),
    );
  }
}
